import { __rest, __assign } from 'tslib';
import clsx from 'clsx';
import React, { useState, useEffect } from 'react';

var Checkbox = function (_a) {
    var children = _a.children, _b = _a.checked, checked = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.inline, inline = _d === void 0 ? false : _d, onChange = _a.onChange, inputProps = __rest(_a, ["children", "checked", "disabled", "inline", "onChange"]);
    var _e = useState(checked), checkedState = _e[0], setCheckedState = _e[1];
    useEffect(function () { return setCheckedState(checked); }, [checked]);
    var handleOnChange = function (e) {
        if (!disabled) {
            setCheckedState(!checkedState);
            if (onChange)
                onChange(e);
        }
    };
    return (React.createElement("label", { className: clsx({
            'c-checkbox': true,
            'c-checkbox--inline': inline,
            'c-checkbox--disabled': disabled
        }) },
        children,
        React.createElement("input", __assign({}, inputProps, { type: 'checkbox', checked: checkedState, disabled: disabled, onChange: handleOnChange })),
        React.createElement("span", { className: 'c-checkmark' })));
};

export { Checkbox };
//# sourceMappingURL=index.js.map
